import * as React from "react";
import {formatDateAndTimeCustom} from "../../../utils/dateUtil";
import {AdminRegion} from "../../../model/RegionLoginContent.model";

export interface AdminLoginPublishedBannerProps {
    region: AdminRegion;
    onUnpublish: (regionId: number) => void;
}

export const PUBLISHED_BANNER_TITLE = "Published — live on the login page";
export const PUBLISHED_BANNER_MESSAGE =
    "Any changes saved below will move this region back to Draft until it is re-published.";
export const UNPUBLISH_BUTTON_TEXT = "Unpublish";
export const PUBLISHED_DATE_FORMAT = "M/D/YYYY, h:mm:ss A";

export const AdminLoginPublishedBanner: React.FunctionComponent<AdminLoginPublishedBannerProps> = ({region, onUnpublish}) => {
    const publishedAt = region.publishedAt
        ? formatDateAndTimeCustom(region.publishedAt, PUBLISHED_DATE_FORMAT)
        : "";
    return (
        <div
            className="admin-login-content__publish-banner admin-login-content__publish-banner--published"
            data-testid="admin-login-content__publish-banner">
            <div className="admin-login-content__publish-banner-content">
                <i className="fa-solid fa-circle-check" />
                <div>
                    <strong>{PUBLISHED_BANNER_TITLE}</strong>
                    <p>
                        {PUBLISHED_BANNER_MESSAGE}
                        {region.publishedBy && <><br/>Published by <span className="admin-login-content__publisher">{region.publishedBy}</span></>}
                        {region.publishedBy && publishedAt && <><br/>on {publishedAt}.</>}
                    </p>
                </div>
            </div>
            {!region.isDefault && (
                <button
                    type="button"
                    className="admin-login-content__btn--unpublish"
                    onClick={() => onUnpublish(region.id)}>
                    <i className="fa-solid fa-ban" /> {UNPUBLISH_BUTTON_TEXT}
                </button>
            )}
        </div>
    );
};
